import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  menu = [
    {
      title: 'Principal',
      icon:  'glyphicon glyphicon-home',
      submenu: [
          {
            title: 'Dashboard',
            icon:  'glyphicon glyphicon-inbox',
            url: '/dashboard'
          },
         /* {
            title: 'Grafica',
            icon:  'glyphicon glyphicon-sort-by-attributes',
            url: '/graficas1'
          }*/
      ]
    },
    {
      title: 'Orders',
      icon: 'glyphicon glyphicon-list',
      submenu: [
       {
         title: 'Add Orders',
         icon:  'glyphicon glyphicon-plus',
         url: '/createOrder'
       },
       {
        title: 'Asign Orders',
        icon:  'glyphicon glyphicon-play',
        url: '/asignOrder'
      },
      {
        title: 'Orders',
        icon:  'glyphicon glyphicon-list-alt',
        url: '/orders'
      },
      {
        title: 'History Orders',
        icon:  'glyphicon glyphicon-home',
        url: '/historyorders'
      },
      {
        title: 'Request Orders',
        icon:  'glyphicon glyphicon-home',
        url: '/requestOrder'
      },
     ]
    },

    {
      title: 'Maps',
      icon: 'glyphicon glyphicon-pushpin',
      submenu: [

       {
        title: 'Tracking',
        icon:  'glyphicon glyphicon-th-list',
        url: '/tracking'
      },
      {
        title: 'Region',
        icon:  'glyphicon glyphicon-home',
        url: '/region'
      }
     ]
    },
     {
      title: 'Customers Settings',
      icon: 'glyphicon glyphicon-user',
      submenu: [
       {
         title: 'Customers',
         icon:  'glyphicon glyphicon-user',
         url: '/customers'
       },
       {
        title: 'Customers App',
        icon:  'glyphicon glyphicon-user',
        url: '/customers-app'
      },
       /*{
        title: 'Add Customers',
        icon:  'glyphicon glyphicon-ok-circle',
        url: '/customerform'
      },*/
     ]
    },
    {
      title: 'Settings',
      icon: 'glyphicon glyphicon-cog',
      submenu: [
        {
          title: 'Users',
          icon:  'glyphicon glyphicon-home',
          url: '/users'
        },
        {
          title: 'Account Settings',
          icon:  'glyphicon glyphicon-share',
          url: '/account-settings'
        },
        {
          title: 'Cars',
          icon:  'fa fa-truck',
          url: '/cars'
        },
        {
          title: 'Items',
          icon:  'glyphicon glyphicon-list',
          url: '/items'
        }
    ]
   },
  ]
  ban:any = false;

  constructor() {


  }

  showMenu(){
     this.ban = true;

  }


}
